<template>
	<path d="M6 4V4C4.59987 4 3.8998 4 3.36502 4.27248C2.89462 4.51217 2.51217 4.89462 2.27248 5.36502C2 5.8998 2 6.59987 2 8V10C2 11.4001 2 12.1002 2.27248 12.635C2.51217 13.1054 2.89462 13.4878 3.36502 13.7275C3.8998 14 4.59987 14 6 14H8C9.40013 14 10.1002 14 10.635 13.7275C11.1054 13.4878 11.4878 13.1054 11.7275 12.635C12 12.1002 12 11.4001 12 10V10"
		stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
	<path d="M7.5 8.5L14 2M14 2H9.5M14 2V6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
		stroke-linejoin="round" />
</template>
